import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Question from '../../common/Question';
import RateInput from '../../common/RateInput';
import TextAreaInput from '../../common/TextAreaInput';
import YesNoInput from '../../common/YesNoInput';
import YesNoInputGroup from '../../common/YesNoInputGroup';
var createOfficeQuestion = function createOfficeQuestion(workLocation, officeLocation, officeDays, daysInOffice) {
  if (!['office', 'both', 'hybrid'].includes(workLocation)) {
    return null;
  }
  var locationClause = officeLocation ? " located in ".concat(officeLocation) : '';
  var daysClause = '';
  if (officeDays && officeDays !== 'not sure' || daysInOffice) {
    var dayWord = daysInOffice === '1' ? 'day' : 'days';
    daysClause = " for at least ".concat(daysInOffice, " ").concat(dayWord, " per week");
  }
  return "Can you work out of the office".concat(locationClause).concat(daysClause, "?");
};
var error = function error(errors, input, typeOfError) {
  return errors && errors[input] === typeOfError;
};
function LogisticsTab(_ref) {
  var project = _ref.project,
    proposal = _ref.proposal,
    onFormChange = _ref.onFormChange,
    errors = _ref.errors,
    nonCompeteUrl = _ref.nonCompeteUrl,
    showBackgroundCheck = _ref.showBackgroundCheck;
  var project_travel_locations = project.project_travel_locations,
    languages = project.languages;
  var currentYear = new Date().getFullYear();
  var startDateYear = project.approximate_start_date_local ? new Date(project.approximate_start_date_local).getFullYear() : 0;
  var dateFormat = startDateYear === currentYear ? 'MMMM Do' : 'MMMM Do, YYYY';
  var travelLocations = project_travel_locations;
  var travelLocationDisplay = [travelLocations.slice(0, -1).join(', '), travelLocations.slice(-1)[0]].join(travelLocations.length < 2 ? '' : ' and ');
  var timeClauses = [];
  if (project.avg_time_required_range && project.avg_time_required_range !== 'not sure') {
    timeClauses.push(project.avg_time_required_text || "".concat(project.avg_time_required_range, " hours per week"));
  }
  if (project.duration_range && project.duration_range !== 'not sure') {
    timeClauses.push(project.duration_with_prefix_text || "for ".concat(project.duration_range, " month duration"));
  }
  if (project.approximate_start_date_local) {
    var startDate = moment(project.approximate_start_date_local).format(dateFormat);
    var past = moment(Date()) > moment(project.approximate_start_date_local);
    timeClauses.push(past ? 'ASAP' : "starting on ".concat(startDate));
  }
  var availabilityQuestion = project.employment_type === 'consulting' ? "Are you available ".concat(timeClauses.join(' '), "?") : null;
  var officeQuestion = createOfficeQuestion(project.work_location, project.office_location, project.office_days, project.days_in_office_from_office_days);
  var allTrue = function allTrue(key) {
    return proposal[key] && proposal[key].every(function (item) {
      return item.selected === 'Yes';
    });
  };
  var isDescEmpty = function isDescEmpty(desc) {
    return !desc || !desc.trim();
  };
  var availabilityError = null;
  if (isDescEmpty(proposal.availability_desc)) {
    availabilityError = errors.availability_desc;
  }
  var workInOfficeError = null;
  if (isDescEmpty(proposal.work_in_office_desc)) {
    workInOfficeError = errors.work_in_office_desc;
  }
  var travelLocationError = null;
  if (isDescEmpty(proposal.travel_locations_desc)) {
    travelLocationError = errors.travel_locations_desc;
  }
  var taxFormError = null;
  if (isDescEmpty(proposal.tax_form_desc)) {
    taxFormError = errors.tax_form_desc;
  }
  var agreementError = null;
  if (isDescEmpty(proposal.agreement_desc)) {
    agreementError = errors.agreement_desc;
  }
  var nonCompeteError = null;
  if (isDescEmpty(proposal.non_compete_desc)) {
    nonCompeteError = errors.non_compete_desc;
  }
  var languagesAllTrue = allTrue('languages');
  var languagesError = null;
  if (!languagesAllTrue && isDescEmpty(proposal.languages_desc)) {
    languagesError = errors.languages_desc && errors.languages_desc[0];
  }
  var numberIndexes = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4 logistics-tab"
  }, availabilityQuestion && project.employment_type === 'consulting' && /*#__PURE__*/React.createElement("div", {
    key: "availability-inputs"
  }, /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". ").concat(availabilityQuestion),
    error: error(errors, 'availability', 'radio_button'),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(YesNoInput, {
    id: "availability",
    className: "ms-4 mt-4",
    showDescriptionInput: true,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('availability', val);
    },
    onDescAnswerChange: function onDescAnswerChange(val) {
      return onFormChange('availability_desc', val);
    },
    errors: errors,
    value: proposal.availability,
    descValue: proposal.availability_desc,
    textPromptClass: availabilityError && 'with-error-text',
    textAreaPrompt: "Tell us more about your availability for this project."
  }))), officeQuestion && /*#__PURE__*/React.createElement("div", {
    key: "work-in-office-inputs"
  }, /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". ").concat(officeQuestion),
    error: error(errors, 'work_in_office', 'radio_button'),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(YesNoInput, {
    id: "work_in_office",
    className: "ms-4 mt-4",
    showDescriptionInput: true,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('work_in_office', val);
    },
    onDescAnswerChange: function onDescAnswerChange(val) {
      return onFormChange('work_in_office_desc', val);
    },
    errors: errors,
    value: proposal.work_in_office,
    descValue: proposal.work_in_office_desc,
    textPromptClass: workInOfficeError && 'with-error-text',
    textAreaPrompt: "Tell us more about your location for this project."
  }))), project_travel_locations.length > 0 && /*#__PURE__*/React.createElement("div", {
    key: "travel-locations-inputs"
  }, /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". Are you able to meet the Travel Requirements: ").concat(travelLocationDisplay, "?"),
    error: error(errors, 'travel_locations', 'radio_button'),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(YesNoInput, {
    id: "travel_locations",
    className: "ms-4 mt-4",
    showDescriptionInput: true,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('travel_locations', val);
    },
    onDescAnswerChange: function onDescAnswerChange(val) {
      return onFormChange('travel_locations_desc', val);
    },
    errors: errors,
    value: proposal.travel_locations,
    descValue: proposal.travel_locations_desc,
    textPromptClass: travelLocationError && 'with-error-text',
    textAreaPrompt: "Tell us more about your traveling availability."
  }))), languages.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Question, {
    className: "qualifications-question mb-5",
    title: "".concat(numberIndexes.shift(), ". Are you fluent in these languages?"),
    location: "proposal-edit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ms-4"
  }, /*#__PURE__*/React.createElement(YesNoInputGroup, {
    options: languages,
    formKey: "languages",
    value: proposal.languages,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('languages', val);
    },
    errors: errors
  })), errors && errors.languages_desc && /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight with-error-text mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), ' ', "Required!"), proposal.languages && proposal.languages.some(function (l) {
    return l.selected !== null;
  }) && /*#__PURE__*/React.createElement("div", {
    className: "ms-4 input-container"
  }, /*#__PURE__*/React.createElement(TextAreaInput, {
    className: "proposal-text-area language-text-area",
    placeholder: "Tell us more...",
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('languages_desc', val);
    },
    error: languagesError,
    textAreaPrompt: "Tell us more about that. (NOT required)",
    textPromptClass: languagesError && 'with-error-text',
    value: proposal.languages_desc
  })))), project.employment_type === 'consulting' && project.tax_type && project.tax_type !== 'n/a' && /*#__PURE__*/React.createElement("div", {
    key: "tax-form-inputs"
  }, /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". This is a ").concat(project.tax_type, " role. Is that ok?"),
    error: error(errors, 'tax_form', 'radio_button'),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(YesNoInput, {
    id: "tax_form",
    className: "ms-4 mt-4",
    showDescriptionInput: true,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('tax_form', val);
    },
    onDescAnswerChange: function onDescAnswerChange(val) {
      return onFormChange('tax_form_desc', val);
    },
    errors: errors,
    value: proposal.tax_form,
    descValue: proposal.tax_form_desc,
    textPromptClass: taxFormError && 'with-error-text'
  }))), /*#__PURE__*/React.createElement("div", {
    key: "agreement-inputs"
  }, /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". Are you already under a non-compete agreement with ANOTHER employer\n  that would prevent you from working on this project?"),
    error: error(errors, 'agreement', 'radio_button'),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(YesNoInput, {
    id: "agreement",
    className: "ms-4 mt-4",
    showDescriptionInput: true,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('agreement', val);
    },
    onDescAnswerChange: function onDescAnswerChange(val) {
      return onFormChange('agreement_desc', val);
    },
    errors: errors,
    value: proposal.agreement,
    descValue: proposal.agreement_desc,
    reverseAnswer: true,
    textPromptClass: agreementError && 'with-error-text'
  }))), project.consultant_needs_sign_agreement && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". Are you willing to sign a non-compete agreement for this project?"),
    error: error(errors, 'non_compete', 'radio_button'),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement("div", null, nonCompeteUrl && /*#__PURE__*/React.createElement("a", {
    className: "non-compete-link",
    href: nonCompeteUrl,
    target: "_blank",
    rel: "noreferrer"
  }, "View non-compete document"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(YesNoInput, {
    id: "non_compete",
    className: "mt-3 ms-4",
    showDescriptionInput: true,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('non_compete', val);
    },
    onDescAnswerChange: function onDescAnswerChange(val) {
      return onFormChange('non_compete_desc', val);
    },
    errors: errors,
    value: proposal.non_compete,
    descValue: proposal.non_compete_desc,
    textPromptClass: nonCompeteError && 'with-error-text'
  }))))), errors && errors.hourly_rate && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight with-error-text mb-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-exclamation-triangle"
  }), ' ', "Required!"), /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight with-error-text mb-2"
  }, "Please enter a number as an hourly rate.")), project.employment_type === 'consulting' && /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". What is your hourly rate?"),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-3 ms-4"
  }, /*#__PURE__*/React.createElement(RateInput, {
    value: proposal.hourly_rate,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('hourly_rate', val);
    },
    placeholder: "Enter rate",
    decimalsAllowed: false
  }))), project.employment_type === 'full_time' && /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". Will you now or in the future require sponsorship to work within the United States?"),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(YesNoInput, {
    id: "us_sponsorship_needed",
    className: "ms-4 mt-4",
    showDescriptionInput: true,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('us_sponsorship_needed', val);
    },
    onDescAnswerChange: function onDescAnswerChange(val) {
      return onFormChange('us_sponsorship_needed_desc', val);
    },
    reverseAnswer: true,
    errors: errors,
    value: proposal.us_sponsorship_needed,
    descValue: proposal.us_sponsorship_needed_desc,
    textPromptClass: "us_sponsorship_needed-text-area ".concat(nonCompeteError && 'with-error-text')
  })), showBackgroundCheck && Array.isArray(project.background_check_type) && project.background_check_type.length > 0 && /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". Are you willing to undergo checks/provide documents as listed?"),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("ol", null, project.background_check_type.map(function (v) {
    return /*#__PURE__*/React.createElement("li", {
      className: "mb-3"
    }, v);
  })), /*#__PURE__*/React.createElement(YesNoInput, {
    id: "background_check_type",
    className: "ms-4 mt-4",
    showDescriptionInput: true,
    onAnswerChange: function onAnswerChange(val) {
      return onFormChange('background_check_type', val);
    },
    onDescAnswerChange: function onDescAnswerChange(val) {
      return onFormChange('background_check_type_desc', val);
    },
    errors: errors,
    value: proposal.background_check_type,
    descValue: proposal.background_check_type_desc,
    textPromptClass: travelLocationError && 'with-error-text',
    textAreaPrompt: "Tell us why you're not willing to undergo the checks or provide the documents listed."
  }))), project.compensation_benefit_note && /*#__PURE__*/React.createElement(Question, {
    title: "".concat(numberIndexes.shift(), ". Compensation & Benefits."),
    location: "proposal-edit",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ms-4"
  }, project.compensation_benefit_note)));
}
LogisticsTab.propTypes = {
  project: PropTypes.shape({}).isRequired,
  proposal: PropTypes.shape({}).isRequired,
  onFormChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  nonCompeteUrl: PropTypes.string,
  showBackgroundCheck: PropTypes.bool
};
LogisticsTab.defaultProps = {
  nonCompeteUrl: null,
  showBackgroundCheck: false
};
export default LogisticsTab;